module.exports = __webpack_public_path__ + "img/ProfileSettings.3513c23e.svg";